import { axios } from '@lib/axios';

import { GetConceptListItemResponse, GetConceptResponse } from 'chaika-frontend-types/frontend-cms';

const BASE_URL = '/api/snomed/concepts';

export class SnomedApi {
    public static async getList(search: string): Promise<GetConceptListItemResponse[]> {
        const res = await axios.get(`${BASE_URL}`, { params: { search } });
        return res.data;
    }

    public static async getById(id: string): Promise<GetConceptResponse> {
        const res = await axios.get(`${BASE_URL}/${id}`);
        return res.data;
    }
}
